import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";
import type { TabBarProps } from "./components/TabBar";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "TabView" */ "./lazyIndex"), {
    name: "TabView",
});

export const TabBar: LazyComponent<TabBarProps, unknown, void> = createLazyComponent(lazyModule, m => m.TabBar);
